module.exports = __webpack_public_path__ + "img/left-line.3e41f3e1.svg";